module.exports = __webpack_public_path__ + "media/images/icons/banda_invitada_xs-6063a2f4888cc1e30da5e31173270fde.svg";